/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type consents_CreateConsentRequest = {
    document_id?: string;
    granted: boolean;
    granted_by_contact_id?: string;
    scope: consents_CreateConsentRequest.scope;
    valid_from: string;
    valid_to?: string;
};
export namespace consents_CreateConsentRequest {
    export enum scope {
        DOCUMENTATION = 'documentation',
        PHOTO_INTERNAL = 'photo_internal',
        PHOTO_PARENT_VISIBLE = 'photo_parent_visible',
        PRINTED_PORTFOLIO = 'printed_portfolio',
        EXTERNAL_SHARING = 'external_sharing',
    }
}

